<template>
  <div>

    <v-data-table :headers="headers" hide-actions :items="data" class="elevation-1">
      <template v-slot:items="props">

        <tr :class="`projet ${props.item.status}`" @click="props.expanded = !props.expanded">

          <td v-if="deposit_history" class="text-xs-left font-weight-bold">{{ props.item.currency.toUpperCase() }}</td>
          <td v-if="deposit_history" class="text-xs-left font-weight-bold">{{ new
            Intl.NumberFormat("fr-FR", { maximumFractionDigits: 6 }).format(props.item.amount)}}</td>
          <td v-if="dp" class="text-xs-left font-weight-bold">{{ new
            Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(props.item.amount)}}</td>
          <td v-if="pm" class="text-xs-left font-weight-bold">{{ new
            Intl.NumberFormat("fr-FR", { maximumFractionDigits: 2 }).format(props.item.amount)}}</td>
          <td v-if="btc" class="text-xs-left font-weight-bold">{{ new
            Intl.NumberFormat("en-US", { maximumFractionDigits: 8 }).format(props.item.amount)}}</td>
          <!-- 'btc withdraw' -->
          <td v-if="dp" class="text-xs-left font-weight-bold">{{ props.item.moyen }}</td>
          <td v-if="pm" class="text-xs-left font-weight-bold">{{ props.item.account || props.item.payer }}</td>
          <td v-if="wBtc" class="font-weight-bold text-xs-center hidden-sm-and-down">{{ props.item.btcAddr }}</td>
          <td v-if="wBtc" class="font-weight-bold text-xs-center hidden-md-and-up">{{ props.item.btcAddr.substring(0,
            10)}}...</td>
          <!-- 'btc deposit' -->
          <td v-if="dpBtc" class="text-xs-center  font-weight-bold hidden-sm-and-down">
            {{ props.item.hash.substring(0, 20) }}...</td>
          <td v-if="dpBtc" class="text-xs-center  font-weight-bold hidden-md-and-up">
            {{ props.item.hash.substring(0, 10) }}...</td>
          <td class="font-weight-bold"><v-chip small :class="`${props.item.status} white--text`">{{ props.item.status
              }}</v-chip> </td>
          <td class="text-xs-left font-weight-bold">{{ props.item.created_at.toDate().toLocaleTimeString('fr-FR', {
            day:
              'numeric', month: 'numeric', year:'numeric'})}}</td>
        </tr>
        <v-divider></v-divider>
      </template>
      <template v-slot:expand="props">
        <vs-tr>
          <vs-td>Montant </vs-td>
          <vs-td>
            {{ new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 6 }).format(props.item.amount) }}
          </vs-td>
        </vs-tr>
        <div v-if="props.item.currency == 'btc' || props.item.currency == 'usdt'">

          <vs-tr v-if="props.item.network && props.item.currency !== 'btc'">
            <vs-td>Reasau </vs-td>
            <vs-td>
              {{ props.item.network }}
            </vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td>Adresse </vs-td>
            <vs-td>
              {{ props.item.address }}
            </vs-td>
          </vs-tr>

          <tr @dblclick="open_explorer(props.item)">
            <td>Hash </td>
            <td>
              {{ props.item.hash }}
            </td>
          </tr>
        </div>  


        <div v-if="props.item.currency == 'cfa'">
          <vs-tr>
            <vs-td>Numero </vs-td>
            <vs-td>
              {{ props.item.address || props.item.number || props.item.numero }}
            </vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td>Moyen </vs-td>
            <vs-td>
              {{ props.item.moyen }}
            </vs-td>
          </vs-tr>
          <vs-tr v-if="props.item.type == 'deposit'">
            <vs-td>ID Transaction </vs-td>
            <vs-td>
              {{ props.item.txid }}
            </vs-td>
          </vs-tr>
        </div>



        <div v-if="props.item.currency == 'pm'">
          <vs-tr>
            <vs-td>compte </vs-td>
            <vs-td>
              {{ props.item.account || props.item.payer }}
            </vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td>Batch </vs-td>
            <vs-td>
              {{ props.item.batch }}
            </vs-td>
          </vs-tr>
        </div>


      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
    },
    headers: {
      type: Array
    },
    dp: {
      type: Boolean
    },
    pm: {
      type: Boolean
    },
    wBtc: {
      type: Boolean
    },
    dpBtc: {
      type: Boolean
    },
    btc: {
      type: Boolean
    },
    deposit_history: {
      type: Boolean
    },
  },
  data() {
    return {
      expanded: false
    }
  },

  methods: {
    gethash(item) {
      item.hash ? window.open(`https://www.blockchain.com/fr/btc/tx/${item.hash}`) : ''
      item.btcAddr ? window.open(`https://www.blockchain.com/fr/btc/address/${item.btcAddr}`) : ''
      item.numero ? swal(`${item.numero}`) : ''
    },
    open_explorer(item) {
      console.log(item);
      item.network == 'TRX' ? window.open(`https://tronscan.org/#/transaction/${item.hash}`) : ''
      item.network == 'BSC' ? window.open(`https://bscscan.com/tx/${item.hash}`) : ''
    },
  },

}
</script>
<style scoped>
table.v-table thead tr th {
  font-size: 1.2em;
}

table.v-table tbody tr td {
  font-size: 15px;
}
</style>
<style>
.v-chip.awaiting,
.v-chip.attente,
.v-chip.Attente,
.v-chip.traitement {
  background: #ffaa2c;
}

.v-chip.complete {
  background: #5b9b47;
}

.v-chip.declined {
  background: rgb(201, 120, 120);
}

.projet.awaiting,
.projet.traitement,
.projet.Attente,
.projet.attente {
  border-left: 7px solid #ffaa2c;
}

.projet.complete {
  border-left: 7px solid #5b9b47;
}

.projet.declined {
  border-left: 7px solid rgb(201, 120, 120);
}
</style>
